import { en } from "./en";
import { tr } from "./tr";

const defaultLanguage = "en";
const languageList = [
  { code: "en", name: "English" },
  { code: "tr", name: "Türkçe" }
];

export default { defaultLanguage, languageList, en, tr };
